import Cookies from "js-cookie";

// Genera la URL de login/redirección a ReservHotel a partir de las cookies de
// sesión del agente. Se reutiliza en la navegación (link directo) y en la
// página de Reserve Hotel (botón). Preserva la lógica original tal cual, incl.
// las credenciales por entorno (sandbox vs. producción) y el caso MXN (167).

import config from '../../configs/config';

export function buildReserveHotelUrl() {
  const countryUser = Cookies.get("CountryUser");
  const agencyCode = Cookies.get("AgencyReservHotelId") || "";
  const agentCode = Cookies.get("AgentReservHotelId") || "";
  const userAccessToken = Cookies.get("UserAccessToken") || "";
  const deviceAccessToken = Cookies.get("DeviceAccessToken") || "";

 
  return `${config.apiurl}ReserveHotelAgentLogin?UserAccessToken=${userAccessToken}&DeviceAccessToken=${deviceAccessToken}&RegisterType=Agent`;
}
